const dateToTime = (date) => {
  return new Date(date).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const dateToDateFormat = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
}

export { dateToTime, dateToDateFormat };